import { useNavigate } from 'react-router';

import { useUserInfo } from '@/utils/hooks/useUserInfo';
import { ROUTES } from '@/utils/routeUtils';
import { cn } from '@/utils/utils';

interface UserInitialIconProps {
  backgroundColor?: 'black' | 'green';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  lg: 'w-8 h-8 text-sm',
  md: 'w-6 h-6 text-xs',
  sm: 'w-5 h-5 text-[10px]',
};

const backgroundColorClasses = {
  black: 'bg-primary',
  green: 'bg-success',
};

export function UserInitialIcon({
  backgroundColor = 'black',
  className,
  size = 'md',
}: UserInitialIconProps) {
  const navigate = useNavigate();
  const { initial: userInitial } = useUserInfo();

  return (
    <div
      aria-label="Profile"
      className={cn(
        'flex cursor-pointer items-center justify-center rounded-full font-medium text-primary-foreground hover:opacity-70',
        sizeClasses[size],
        backgroundColorClasses[backgroundColor],
        className,
      )}
      onClick={() => navigate(ROUTES.PROFILE)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigate(ROUTES.PROFILE);
        }
      }}
      role="button"
      tabIndex={0}
    >
      {userInitial}
    </div>
  );
}
